import { useOpenChatbot } from "@/shared/hooks/useOpenChatbot";
import { App_Url, getChatbotName, getWhatsAppUrl } from "@/whiteLable";

export default function FloatingButtons() {
  const openWhatsApp = () => {
    window.open(getWhatsAppUrl(), "_blank", "noopener,noreferrer");
  };
  const { openChatbot, isAuthenticated } = useOpenChatbot();
  const chatbotName = getChatbotName();

  const buttonClass =
    "flex items-center justify-center rounded-full " +
    "w-12 h-12 md:w-14 md:h-14 " +
    "bg-transparent shadow-lg " +
    "transition-transform duration-200 hover:scale-105 active:scale-95";

  const iconClass = "w-10 h-10 md:w-12 md:h-12 object-contain";

  // Authenticated users get an "Ask Layla" button in the auth header instead.
  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-40 flex flex-col gap-2 md:bottom-6 md:right-6 md:gap-3">
      {/* WhatsApp Button */}
      <button
        type="button"
        aria-label="Chat on WhatsApp"
        onClick={openWhatsApp}
        className={buttonClass}
      >
        <img src={App_Url.public.Whatsapp} alt="WhatsApp" className={iconClass} />
      </button>

      {/* Chatbot Button */}
      <button
        type="button"
        aria-label={`Open Ask ${chatbotName}`}
        title={`Ask ${chatbotName}`}
        onClick={openChatbot}
        className={buttonClass}
      >
        <img src={App_Url.public.ChatBot} alt={`Ask ${chatbotName}`} className={iconClass} />
      </button>
    </div>
  );
}
